












































































































































import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteProcedimentosStore from '@/components/Suporte/Store/SuporteProcedimentosStore'
import { onlyNumber } from '@/utils/common'

@Component
export default class ComponentModalSuporteProcedimento extends Vue {
  loadSaveOrUpdateProcedimento: boolean = false

  get getSuporteProcedimentosStore() {
    return getModule(SuporteProcedimentosStore, this.$store)
  }

  get loadingSaveOrUpdateProcedimento() {
    return this.loadSaveOrUpdateProcedimento
  }

  set loadingSaveOrUpdateProcedimento(value: boolean) {
    this.loadSaveOrUpdateProcedimento = value
  }

  get showModalProcedimento() {
    return this.getSuporteProcedimentosStore.modal.procedimento
  }

  set showModalProcedimento(value: boolean) {
    this.getSuporteProcedimentosStore.setModal({ name: 'procedimento', value })
  }

  $refs!: {
    formProcedimento: any
  }

  formProcedimentoRules: any = {
    valid: true,
    codigo: [(v: any) => !!v || 'Campo obrigatório.'],
    descricao: [(v: any) => !!v || 'Campo obrigatório.'],
    status: [(v: any) => !!v || 'Campo obrigatório.'],
    tipo: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  async saveOrUpdateProcedimento() {
    this.loadingSaveOrUpdateProcedimento = true

    if (this.$refs.formProcedimento.validate()) {
      const { mode } = this.getSuporteProcedimentosStore

      const response = await this.getSuporteProcedimentosStore.upsertProcedimentoHospital()

      if (response.success) {
        const procedimentoId = response.data
        await this.getSuporteProcedimentosStore.upsertProcedimentoTecnica({
          procedimentoId,
          tecnicasIds: this.getSuporteProcedimentosStore.procedimento.tecnicasDoProcedimento.map(tecnica => tecnica.id),
        })
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Procedimento ${mode === 'CREATE' ? 'criado' : 'alterado'} com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })

        await this.getSuporteProcedimentosStore.getProcedimentoPagedSearch(this.getSuporteProcedimentosStore.paginationProcedimento)
        this.showModalProcedimento = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao ${mode === 'CREATE' ? 'criar' : 'alterar'} o procedimento ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOrUpdateProcedimento = false
  }

  @Watch('showModalProcedimento')
  onChangeShowModalProcedimento(value: boolean) {
    if (!value) {
      this.getSuporteProcedimentosStore.clearProcedimento()
      this.getSuporteProcedimentosStore.clearTecnicasDoProcedimento()
      this.getSuporteProcedimentosStore.setMode({ mode: 'CREATE' })
      this.$refs.formProcedimento.resetValidation()
    }
  }
}
